module.exports = __webpack_public_path__ + "static/media/hero-animaatio.f893a8f.mp4";


//////////////////
// WEBPACK FOOTER
// ./static/hero-animaatio.mp4
// module id = 2FUU
// module chunks = 1